module.exports = __webpack_public_path__ + "static/img/spread3-2.b80b778.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread3-2.jpg
// module id = fGiF
// module chunks = 1